import styled from "styled-components";

import { Link, ExternalLink } from "ui/Link";
import { Alert } from "ui/alert";
import { YoutubeChannel } from "api/social-account-connect/youtube";

import { LoginWithGoogleButton } from "../login-with-google-button";
import { GetConnectButtonState } from "../connect-button";
import { AccountList } from "../account-list";

interface YoutubeChannelListProps {
  className?: string;
  channels: YoutubeChannel[];
  onConnect(chan: YoutubeChannel): void;
  getConnectButtonState: GetConnectButtonState<YoutubeChannel>;
  LoginWithGoogleButtonProps: {
    disabled: boolean;
    onClick(): void;
  };
}

export function YoutubeChannelList({
  className,
  channels,
  onConnect,
  getConnectButtonState,
  LoginWithGoogleButtonProps,
}: YoutubeChannelListProps) {
  return (
    <Root className={className}>
      <p>
        You've already connected your Google account to Sked. Below are the
        available YouTube channels for that Google account.
      </p>
      <p>
        If the YouTube channel you are looking for is not shown, click the 'Sign
        in with Google' button below and select the correct Google account.
      </p>
      <p>
        If you need to change the Google account permissions you have given to
        us, use{" "}
        <ExternalLink href="https://myaccount.google.com/permissions">
          Google's permissions tool
        </ExternalLink>
        .
      </p>
      <h4>Available channels</h4>
      {channels.length > 0 && (
        <AccountList
          items={channels}
          onConnect={onConnect}
          renderItemLabel={(chan) => (
            <>
              {chan.snippet.title} ({" "}
              <Link
                href={`https://www.youtube.com/channel/${chan.id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                @{chan.login}
              </Link>
              )
            </>
          )}
          getConnectButtonState={getConnectButtonState}
        />
      )}
      {channels.length === 0 && (
        <Alert>No YouTube channels were returned</Alert>
      )}
      <h4>Dont see your channel in the list?</h4>
      <Caption>
        Try reconnecting your Google account or signing in into another one:
      </Caption>
      <ButtonContainer>
        <LoginWithGoogleButton {...LoginWithGoogleButtonProps} />
      </ButtonContainer>
    </Root>
  );
}

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const Caption = styled.p`
  font-size: 14px;
`;

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 8px;

  & > * {
    margin: 0;
  }
`;
